import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import awbRemote from '../../api/awbRemote';
import cartRemote from '../../api/cartRemote';
import paymentsRemote from '../../api/paymentsRemote';
import offlineRfsRemote from '../../api/offlineRfsRemote';
import { baseUrl } from '../../api/baseUrl';

import { receiveError, receiveSuccess } from '../../store/actions/notificationAction';

import ApiResponse from '../../models/ApiResponse';
import ResponseError from '../../models/ResponseError';
import AwbDetails from '../../models/AwbDetails';
import Awb from '../../models/Awb';
import PickupOrder from '../../models/PickupOrderGha';
import AwbParams from '../../models/AwbParams';
import { History } from 'history';

import { extractAwbCodeAndNumber } from '../../utils/airwayBill';

import AwbInfoSearchContainer from './awbInfoSearch/AwbInfoSearchContainer';
import AwbInfoGeneralComponent from './AwbInfoGeneralComponent';
import PaymentInfoComponent from './PaymentInfoComponent';
import OrderInfoComponent from './OrderInfoComponent';
import CustomsInfoComponent from './customsInfo';
import PoDModalContainer from '../poD/PoDModalContainer';
import AttachmentsContainer from '../attachments/AttachmentsContainer';
import ReadyForCarriageCheckContainer from '../readyForCarriageCheck/ReadyForCarriageCheckContainer';
import OrderExceptionNoteContainer from './orderExceprionNote/OrderExceptionNoteContainer';
import AwbReportContainer from './awbReport/awbReportContainer';
import PaymentAwbInfo from '../../models/PaymentAwbInfo';

import style from './awbInfo.module.css';
import commonStyles from '../common/common.module.css';
import { Button } from '@material-ui/core';
import MaterialTable from 'material-table';
import tableIcons from '../../utils/editTableIcons';
import AwbReturnModalContainer from './awbReturn/AwbReturnModalContainer';
import DriverData from '../../models/DriverData';
import AdditionalServicesModalContainer from '../cart/additionalServices/additionalServicesModal/AdditionalServicesModalContainer';
import CertifiedManifestChargeModal from '../cart/additionalServices/certifiedManifestCharge/CertifiedManifestChargeModal';
import User, { UserRoleType } from '../../models/User';
import AddAWBModalContainerImport from '../forwarderImport/addAWBModal/AddAWBModalContainer';
import AddAWBModalContainerExport from '../forwarderExport/addAWBModal/AddAWBModalContainer';
import GeneralRemarksView from '../common/generalRemarks/GeneralRemarksView';
import { receiveButtonState } from '../../store/actions/disableApiCall';
import MultipleAwbs from './MultipleAwbs';
import validation from '../../utils/validation';

interface AwbInfoContainerProps {
  receiveSuccess: (msg: string) => void;
  receiveError: (error: ResponseError) => void;
  user: User;
  history: History;
  setButtonState: (value: boolean) => void;
};

const DRIVER_DATA_INITIALS: DriverData = {
  name: '',
  company: '',
  check_in: null
};

interface AwbInfoContainerState { 
  awb: Array<Awb>;
  paymentInfo: Array<PaymentAwbInfo>;
  pickupOrders: Array<PickupOrder>;
  isModalPoDOpen: boolean;
  awbCode: string;
  awbNumber: string;
  awbVersion: number;
  isAttachmentsDialogOpen: boolean;
  isRForCheckDialogOpen: boolean;
  orderNumber: string;
  isModalOpenImport: boolean;
  isModalOpenExport: boolean;
  isOrderNoteDialogOpen: boolean;
  driverData: DriverData;
  isAwbReportDialogOpen: boolean;
  orderType: string;
  awbReturnDialogOpen: boolean; 
  addServicesModalOpen: boolean;
  returnAvailability: boolean;
  generalRemarks: string;
  multipleAwbModal: boolean;
  multipleAwbs: Array<Awb>;
  selectedAwb: Awb;
  offlineRfs?: Array<any>;
  manifestAwbs: Array<Awb>;
  manifestModalOpen?: boolean;
};

class AwbInfoContainer extends Component <AwbInfoContainerProps, AwbInfoContainerState> {

  state: AwbInfoContainerState = {
    awb: [],
    paymentInfo: [],
    pickupOrders: [],
    driverData: DRIVER_DATA_INITIALS,
    isModalPoDOpen: false,
    isModalOpenImport: false,
    isModalOpenExport: false,
    awbCode: '',
    awbNumber: '',
    isAttachmentsDialogOpen: false,
    isRForCheckDialogOpen: false,
    orderNumber: '',
    isOrderNoteDialogOpen: false,
    isAwbReportDialogOpen: false,
    orderType: '',
    awbReturnDialogOpen: false,
    addServicesModalOpen: false,
    returnAvailability: false,
    generalRemarks: '',
    multipleAwbModal: false,
    multipleAwbs: [],
    awbVersion: 0,
    selectedAwb: {} as Awb,
    offlineRfs: [],
    manifestAwbs: [],
    manifestModalOpen: false
  }
  
  search = (awbNumber: string): void => {
    
    if (validation.validateAWB(awbNumber)) {
      awbRemote.getAwbs(awbNumber).then(resp => {
        const awbsInfo: any | undefined = resp.result;
        const error: ResponseError | undefined = resp.error;

        if (error) {
          this.props.receiveError(error);
        }
        if(!awbsInfo) {
          return;
        }
        if (awbsInfo.awbs.length < 2) {
          this.setState({ awbVersion: 1 }, () => {
            this.searchAwb(awbNumber);
          });
        }

        if (awbsInfo.awbs.length > 1) {
          this.setState({ multipleAwbModal: true, multipleAwbs: awbsInfo.awbs });
        }
      });
    }
  }
  
  handleClose = (): void => {
    this.setState({ addServicesModalOpen: false });
  }

  confirmAwb = (): void => {
    const awb = this.state.selectedAwb;
    this.setState({ awbVersion: awb.version, multipleAwbModal: false }, () => {
      const awbNumber = awb.code + '-' + awb.number;
      this.searchAwb(awbNumber);
    });
  }

  searchAwb = (awbNumber: string): void => {
    const awbParams: AwbParams = extractAwbCodeAndNumber(awbNumber);
    this.props.setButtonState(true);
    awbRemote.getAwbInfo(awbParams.awbCode, awbParams.awbNumber, this.state.awbVersion).then((res: ApiResponse<AwbDetails>) => {
      this.props.setButtonState(false);
      const result: AwbDetails | undefined = res.result;
      const error: ResponseError | undefined = res.error;

      if (result) {
        this.setState({ 
          awb: [result.awb], 
          paymentInfo:result.paymentInfo, 
          pickupOrders: result.pickupOrders,
          awbCode: awbParams.awbCode,
          awbNumber: awbParams.awbNumber,
          orderType: result.pickupOrders[0] ? result.pickupOrders[0].order_type : '',
          returnAvailability: result.returnAvailability,
          generalRemarks: result.generalRemarks,
          offlineRfs: result.offlineRfs
        });

        if (result.offlineRfs && result.offlineRfs.length > 0) {
          offlineRfsRemote.getOfflineOrderAwbs(result.offlineRfs[0].id_offline_rfs.toString()).then((resp: ApiResponse<Awb[]>) => {
            if (resp.result) {
              this.setState({ manifestAwbs: resp.result });
            }
          });
        }
      } 
      if (error) {
        this.props.receiveError(error);
      }
    });
  }

  selectAwb = (awb: Awb): void => {
    this.setState({ selectedAwb: awb, awbVersion: awb.version });
  }

  handleOpenParts = (awb: Awb, requestId?: string): void => {
    if(this.state.orderType === 'do') {
      this.setState({ isModalOpenExport: true });
    } else {
      this.setState({ isModalOpenImport: true });
    }
  };

  handleEdit = (awbData: Awb, opt: {edited: boolean, metadata: boolean}): void => {
    const isExport = this.state.orderType === 'do' ? true : false
    awbRemote.editAwb(awbData, '', opt.metadata, isExport, this.state.orderNumber).then((resp: ApiResponse<Awb>) => {

      const awb: Awb | undefined = resp.result;
      const error: ResponseError | undefined = resp.error;

      if (awb) {
        const state: any = isExport ?  { isModalOpenExport: false } : { isModalOpenImport: false };
        this.setState(state, () => {
          this.search(this.state.awbCode + '-' + this.state.awbNumber);
        })
      };

      if (error) {
        this.props.receiveError(error);
      };
    });
  };

  handleOpenModal = (modalType: string, orderNumber? : string) : void => {
    switch(modalType) {
      case 'pod' : this.setState({ isModalPoDOpen: true }); break;
      case 'awbReturn' : this.setState({ awbReturnDialogOpen: true }); break;
      case 'addCharges' : this.setState({ addServicesModalOpen: true }); break;
      case 'addManifestCharge' : 
        this.addManifestServiceToCart();
        break;
      case 'attachments': this.setState({ isAttachmentsDialogOpen: true}); break;
      case 'rForCheck' : this.setState({ isRForCheckDialogOpen: true, orderNumber: orderNumber? orderNumber: ''}); break;
      case 'orderNote' : this.setState({isOrderNoteDialogOpen: true, orderNumber: orderNumber? orderNumber: ''}); break;
      default: break;
    }
  }

  addManifestServiceToCart = () => {
    let currentAwb = this.state.awb[0];
    const isExport = this.state.orderType === 'do';
    const cartReq = isExport ? 
      cartRemote.addExportAirwayBillToCart(currentAwb.code, currentAwb.number, currentAwb.version, true) : 
      cartRemote.addAirwayBillToCart(currentAwb.code, currentAwb.number, currentAwb.version, '', true);

    cartReq.then((resp: ApiResponse<any>) => {
      if (!resp.error || resp.error.errorCode === 'already-added-to-cart' || resp.error.errorCode === '#alreadyInCart') {
        const params = [{
          type: 'certified_manifest_charge',
          params: { transaction_date: moment().format('YYYYMMDD') },
          additional_info: ''
        }];
        cartRemote.addServiceToCart(currentAwb.code, currentAwb.number, currentAwb.version, params, isExport).then(respService => {
          if (respService.result) {
            this.setState({ manifestModalOpen: true });
          } else if (respService.error && (this.props as any).receiveError) {
            (this.props as any).receiveError(respService.error);
          }
        });
      } else if ((this.props as any).receiveError) {
        (this.props as any).receiveError(resp.error);
      }
    });
  }

  handleOpenAwbReportModal = (orderNumber: string, orderType: string): void => {
    const url: string = `${baseUrl}awb/${this.state.awbCode}/${this.state.awbNumber}/${this.state.awbVersion}/exception/file`;
    window.open(url);
  }

  handleAddAndPayManifest = (transactionDate: string, paymentMethod: string, paymentOther: string) => {
    let currentAwb = this.state.awb[0];
    const isExport = this.state.orderType === 'do';
    
    // Manifest charge was already added when the modal opened, but with current date
    // Update the transaction date directly and proceed to payment
    const paramOptions = {
      type: 'certified_manifest_charge',
      params: { transaction_date: transactionDate },
      additional_info: ''
    };
    
    cartRemote.updateServiceToCart(currentAwb.code, currentAwb.number, paramOptions, isExport).then(respService => {
      if (respService.result) {
        let finalPaymentInfo = paymentMethod === 'other' ? paymentOther : paymentMethod;
        cartRemote.cartPay(false, finalPaymentInfo, 'alternative payment', undefined, undefined, false, isExport).then(respPay => {
          if (respPay.result) {
            const awbIdentifier = `${currentAwb.code}-${currentAwb.number}`;
            this.setState({ manifestModalOpen: false }, () => {
              this.searchAwb(awbIdentifier);
              this.props.receiveSuccess('Certified manifest charge paid successfully');
            });
          } else if (respPay.error) {
            if ((this.props as any).receiveError) (this.props as any).receiveError(respPay.error);
          }
        });
      } else if (respService.error) {
        if ((this.props as any).receiveError) (this.props as any).receiveError(respService.error);
      }
    });
  }

  deleteManifestCharge = (isConfirmed?: boolean) => {
    let currentAwb = this.state.awb[0];
    const isExport = this.state.orderType === 'do';
    if (isConfirmed) {
      paymentsRemote.deleteConfirmedService(currentAwb.code, currentAwb.number, currentAwb.version, 'certified_manifest_charge').then(() => {
        this.search(`${currentAwb.code}-${currentAwb.number}`);
        this.props.receiveSuccess('Certified manifest charge successfully deleted');
      }).catch((err: any) => {
        this.props.receiveError(err.message || 'Error deleting charge');
      });
    } else {
      cartRemote.deleteServiceFromCart(currentAwb.code, currentAwb.number, 'certified_manifest_charge', '', isExport).then((resp: any) => {
        this.search(`${currentAwb.code}-${currentAwb.number}`);
        this.props.receiveSuccess('Certified manifest charge successfully deleted');
      }).catch((err: any) => {
        this.props.receiveError(err.message || 'Error deleting charge');
      });
    }
  };

  handleCloseModal = (modalType: string): void => {
    switch(modalType) {
      case 'pod' : this.setState({ isModalPoDOpen: false }); break;
      case 'awbReturn' : this.setState({ awbReturnDialogOpen: false }); break;
      case 'addCharges' : this.setState({ addServicesModalOpen: false }); break;
      case 'addManifestCharge' : 
        this.removeManifestServiceFromCart();
        break;
      case 'attachments':  this.setState({ isAttachmentsDialogOpen: false }); break;
      case 'rForCheck' : this.setState({ isRForCheckDialogOpen: false, orderNumber: ''}); break;
      case 'orderNote' : this.setState({isOrderNoteDialogOpen: false, orderNumber:' '}); break;
      case 'awbReport': this.setState({isAwbReportDialogOpen: false, orderNumber: '', orderType: ''}); break;
      case 'history' : this.setState({ multipleAwbModal: false}); break;
      default: break;
    }
  }

  removeManifestServiceFromCart = () => {
    let currentAwb = this.state.awb[0];
    const isExport = this.state.orderType === 'do';
    cartRemote.deleteServiceFromCart(currentAwb.code, currentAwb.number, 'certified_manifest_charge', '', isExport).then((resp: ApiResponse<any>) => {
      this.setState({ manifestModalOpen: false });
    });
  }

  printOrder = (orderNumber: string) => {
    
    const url: string = `${baseUrl}pickup_order/${orderNumber}/awb/${this.state.awbCode}/${this.state.awbNumber}/${this.state.awbVersion}/file`;
    window.open(url);
  }

  render() {
    return (
      <div>
        <div className= { commonStyles.headerDummyDiv }> </div>
        <div className={ commonStyles.searchWrapperOuter }>
          <AwbInfoSearchContainer
            search={ this.search }
            label = 'Number or Airwaybill'
            type='info'
          />
        </div>

        { this.state.awb.length >0 &&
          <AwbInfoGeneralComponent 
            awb={ this.state.awb } 
            orderType={ this.state.orderType }
            hasManifestCharge={ (this.state.paymentInfo && this.state.paymentInfo.some(p => p.service === 'certified_manifest_charge')) || false }
            handleOpenModal={ this.handleOpenModal }
            user={ this.props.user }
            openParts={ this.handleOpenParts }
          />
        }

        { this.state.isModalOpenImport &&
          <AddAWBModalContainerImport 
            modalOpen={ this.state.isModalOpenImport }
            awb={ this.state.awb[0] }
            handleSave={ this.handleEdit }
            handleCloseModal={() => { this.setState({ isModalOpenImport: false }) }}
            awbActionOfUpdateButton={ 'update' }
            handleOpenPoD={  this.handleOpenModal }
            awbInfo={ true }
          />
        }

        { this.state.isModalOpenExport &&
          <AddAWBModalContainerExport 
            modalOpen={ this.state.isModalOpenExport }
            awb={ this.state.awb[0] }
            handleSave={ this.handleEdit }
            handleCloseModal={() => { this.setState({ isModalOpenExport: false }) }}
            awbActionOfUpdateButton={ 'update' }
            awbInfo={ true }
            edited={ false }
            userRole={ UserRoleType.GHA }
          />
        }

        { this.state.paymentInfo.length > 0 &&
          <PaymentInfoComponent paymentInfo={ this.state.paymentInfo } deleteManifestCharge={this.deleteManifestCharge} />
        }
       
        { this.state.pickupOrders.length > 0 && 
          <OrderInfoComponent 
            pickupOrders={ this.state.pickupOrders } 
            awbNumber={ this.state.awbNumber }
            awbCode={ this.state.awbCode }
            handleOpenModal={ this.handleOpenModal }
            handleOpenAwbReportModal={ this.handleOpenAwbReportModal }
            printOrder={ this.printOrder }
            history={ this.props.history }
            offlineRfs={ this.state.offlineRfs }
            awb={ this.state.awb[0] }
          />
        }

        { this.state.paymentInfo.length > 0 && this.state.paymentInfo[0].first_payment_status_history !== this.state.paymentInfo[0].latest_payment_status_history && this.state.paymentInfo[0].confirmed_payment_name &&
          <CustomsInfoComponent 
            userId={ this.state.paymentInfo[0].confirmed_payment_name }
            timeStamp={ this.state.paymentInfo[0].confirmed_time } 
          />
        }

        { this.state.isModalPoDOpen && 
         <PoDModalContainer 
          isModalOpen={ this.state.isModalPoDOpen }
          handleCloseModal={ this.handleCloseModal }
          code={ this.state.awbCode }
          number={ this.state.awbNumber }
          version={ this.state.awbVersion }
          />
        }

        { this.state.isAttachmentsDialogOpen && 
          <AttachmentsContainer
            code={ this.state.awbCode }
            number={ this.state.awbNumber }
            version={ this.state.awbVersion }
            process='export'
            closeAttachments={ () => this.handleCloseModal('attachments') }
            refreshAwbs={ true }
            onlyRead={ true }
          />
        }

        { this.state.isRForCheckDialogOpen && 
          <ReadyForCarriageCheckContainer 
            doNumber={ this.state.orderNumber }
            code={ this.state.awbCode }
            number={ this.state.awbNumber }
            version={ this.state.awb[0].version }
            handleClose={ () => this.handleCloseModal('rForCheck') }
            onlyRead={ true }
          />
        }

        { this.state.isOrderNoteDialogOpen &&
          <OrderExceptionNoteContainer 
            number={ this.state.orderNumber }
            handleClose={ this.handleCloseModal }
          />
        }

        { this.state.isAwbReportDialogOpen &&
          <AwbReportContainer 
            type={ this.state.orderType }
            code={ this.state.awbCode }
            number={ this.state.awbNumber }
            orderNumber={ this.state.orderNumber }
            handleClose={ this.handleCloseModal }
          />
        }

        { this.state.awbReturnDialogOpen &&
          <AwbReturnModalContainer 
            modalOpen={ this.state.awbReturnDialogOpen }
            handleCloseModal={ this.handleCloseModal }
            driverData={ this.state.driverData }
            handleOpenModal={ this.handleOpenModal }
            awbNumber={ this.state.awbCode + '-' + this.state.awbNumber }
            order={ this.state.pickupOrders[0] }
            awb={ this.state.awb[0] }
            selectedAwbCode={ this.state.awb[0].code }
            selectedAwbNumber={ this.state.awb[0].number }
            history={ this.props.history }
          />
        }
        { this.state.awb.length > 0 && this.state.generalRemarks &&
          <GeneralRemarksView
            generalRemarks={ this.state.generalRemarks }
          />
        }
        { this.state.multipleAwbModal && 
         <MultipleAwbs 
            modalOpen={ this.state.multipleAwbModal }
            handleClose={ this.handleCloseModal }
            awbHistory={ this.state.multipleAwbs }
            proceed={ this.confirmAwb }
            selectAwb={ this.selectAwb }
            awb={ this.state.selectedAwb }
            user={ this.props.user }
          />
        }
        {
          this.state.pickupOrders[0] &&
          <Button 
            color="primary"
            variant="contained" 
            onClick={ () => this.handleOpenModal('awbReturn') }
            className= { style.returnButton }
            disabled={ !this.state.returnAvailability || this.props.user.gha_id !== this.state.pickupOrders[0].id_gha }
          > 
            Process Return
          </Button>
        }
        { this.state.addServicesModalOpen &&
           <AdditionalServicesModalContainer
            modalOpen={ this.state.addServicesModalOpen }
            handleClose={ this.handleClose }
            selectedAwbCode={ this.state.awbCode }
            selectedAwbNumber={ this.state.awbNumber }
            selectedAwbVer={ this.state.awb[0].version }
            isExport={ this.state.orderType === 'do' }
          />
        }
        
        { this.state.manifestModalOpen &&
          <CertifiedManifestChargeModal
            modalOpen={ this.state.manifestModalOpen }
            awb={ this.state.awb[0] }
            handleClose={ () => this.handleCloseModal('addManifestCharge') }
            handleAddAndPay={ this.handleAddAndPayManifest }
          />
        }
      </div> 
    );
  }
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    receiveError: (error: ResponseError) => dispatch(receiveError(error)),
    receiveSuccess: (msg: string) => dispatch(receiveSuccess(msg)),
    setButtonState: (value: boolean) => dispatch(receiveButtonState(value))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AwbInfoContainer);